import {StyleSheet} from "react-native";
import {styleVars} from "../../../app-style-vars";

export const styles = StyleSheet.create({
  orderPriceDetailsContainer: {
    zIndex: 1,
  },
  orderPriceDetailsHeader: {
    paddingVertical: styleVars.rem(.5),
  },
  orderPriceDetailsHeaderText: {
    color: styleVars.boschDarkBlue,
    fontSize: styleVars.rem(1),
  },
  flyoutContainer: {
    padding: styleVars.rem(.5),
    borderWidth: 1,
    borderColor: styleVars.boschLightGray,
    backgroundColor: '#fff',
  },
  flyoutHeader: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: styleVars.rem(.5),
  },
  flyoutHeaderText: {
    fontWeight: '600',
  },
  flyoutRow: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: styleVars.rem(.5),
  },
  priceLabel: {
    maxWidth: '45%',
  },
  priceLabelText: {
    fontSize: styleVars.rem(.875),
    color: styleVars.boschDarkBlue,
  },
  priceValue: {
    maxWidth: '50%',
  },
  priceValueText: {
    fontSize: styleVars.rem(.875),
    color: styleVars.boschDarkBlue,
  }
})